import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    theme: {
        themes: {
            light: {
                primary: '#17acac',
                secondary: '#ED4679',
                accent: '#8c9eff',
                error: '#b71c1c',
            },
        },
    },
});
